<script lang="ts">
export type BlockItemProps = {
    icon?: string;
    index?: number;
    title?: string;
    description?: string;
    loading?: boolean;
};
</script>
<script setup lang="ts">
// PROPS
const { index } = defineProps<BlockItemProps>();

// DATA
const idx = computed(() => (index ? formatBlockIndex(index) : undefined));
</script>

<template>
    <div class="flex flex-col justify-start gap-y-4 rounded-xl border border-neutral-300 p-6 md:gap-y-6 md:p-8">
        <div v-if="idx" class="text-primary font-bold">{{ idx }}</div>
        <UIcon v-if="icon" :name="icon" class="h-9 w-9 md:h-12 md:w-12 xl:h-16 xl:w-16" />
        <div class="flex flex-col gap-y-1 md:gap-y-2 xl:gap-y-3">
            <template v-if="title">
                <USkeleton v-if="loading" class="h-8 w-[50%]" />
                <p v-else class="text-2xl font-semibold">
                    {{ title }}
                </p>
            </template>
            <template v-if="description">
                <USkeleton v-if="loading" class="h-7" />
                <p v-else class="text-lg">
                    {{ description }}
                </p>
            </template>
        </div>
    </div>
</template>
